export default __webpack_public_path__ + "f3ba9a533a3ad8e9e7b15c4a3810aa07.mp3";